fragment flexibleVideo on flexibleSections_video_BlockType {
    videoUrl
    accessibleVideoUrl: videoUrl2
    title: plaintext
    caption
}
